var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"node-tree"},_vm._l((_vm.inputValue),function(node,i){return _c('TreeNode',{key:i,on:{"nodeSelected":_vm.nodeSelected},model:{value:(_vm.inputValue[i]),callback:function ($$v) {_vm.$set(_vm.inputValue, i, $$v)},expression:"inputValue[i]"}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39e4484f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shell/components/treebox/TreeBox.vue
// module id = 325
// module chunks = 0